"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.observeStore = exports.getSolutions = exports.getSession = exports.getAppconfig = void 0;
var _configureStore = _interopRequireDefault(require("../store/configureStore"));
const getSolutions = () => _configureStore.default.instance.getState().menu.solutions;
exports.getSolutions = getSolutions;
const getSession = () => _configureStore.default.instance.getState().session.entity;
exports.getSession = getSession;
const getAppconfig = () => _configureStore.default.instance.getState().appconfig.entity;
exports.getAppconfig = getAppconfig;
const observeStore = (select, onChange) => {
  let currentState;
  const handleChange = () => {
    const nextState = select(_configureStore.default.instance.getState());
    if (nextState !== currentState) {
      currentState = nextState;
      onChange(currentState);
    }
  };
  const unsubscribe = _configureStore.default.instance.subscribe(handleChange);
  handleChange();
  return unsubscribe;
};
exports.observeStore = observeStore;